/**
 * Sprint 24.17.1.9 → 24.17.1.11 — Hex-based state color registry with
 * timeline-specific opacity stops.
 *
 * Maps workflow state names to raw RGB values and pre-computed rgba() stops
 * for the active-step composite treatment (card bg, halo, border, past fills).
 */

export interface StateTimelineColors {
  base: string;
  cardBg09: string;
  haloBg16: string;
  cardBorder28: string;
  pastFill10: string;
  border25: string;
}

function makeColors(r: number, g: number, b: number): StateTimelineColors {
  return {
    base: `rgb(${r}, ${g}, ${b})`,
    cardBg09: `rgba(${r}, ${g}, ${b}, 0.09)`,
    haloBg16: `rgba(${r}, ${g}, ${b}, 0.16)`,
    cardBorder28: `rgba(${r}, ${g}, ${b}, 0.28)`,
    pastFill10: `rgba(${r}, ${g}, ${b}, 0.10)`,
    border25: `rgba(${r}, ${g}, ${b}, 0.25)`,
  };
}

const FALLBACK_COLORS = makeColors(107, 114, 128);

const STATE_COLORS: Record<string, StateTimelineColors> = {
  // document-workflow states
  drafting: makeColors(245, 158, 11),
  "in-review": makeColors(234, 88, 12),
  approved: makeColors(16, 185, 129),
  cancelled: makeColors(107, 114, 128),
  failed: makeColors(220, 38, 38),
  running: makeColors(59, 130, 246),
  // sprint-spec aliases
  draft: makeColors(245, 158, 11),
  dispatched: makeColors(59, 130, 246),
  shipped: makeColors(16, 185, 129),
  // Sprint 25.2 — focus state (indigo)
  focus: makeColors(99, 102, 241),
};

export function getStateTimelineColors(state: string): StateTimelineColors {
  return STATE_COLORS[state] ?? FALLBACK_COLORS;
}
